import { render } from "./StageDynamicBudget.vue?vue&type=template&id=c274e8fc&scoped=true"
import script from "./StageDynamicBudget.vue?vue&type=script&lang=js"
export * from "./StageDynamicBudget.vue?vue&type=script&lang=js"

import "./StageDynamicBudget.vue?vue&type=style&index=0&id=c274e8fc&lang=scss&scoped=true"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c274e8fc"]])

export default __exports__